import type { RootState } from "store/types";

// `theme` (src/reducers/theme.js) - containers/Application (PLAY-5216, Phase 4). Stays Immutable
// and opaque: Application only ever calls `.toJSON()` on it to build an inline style object.
export function selectTheme(state: RootState): any {
  return state.theme;
}
